



































import Vue from "vue";

export default Vue.extend({
  name: "OpenDialog",
  data: () => ({
    copied: false,
  }),
  computed: {
    baseURL(): string {
      let getUrl = window.location;
      let baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
      //return getUrl.href;
      return baseUrl;
    },
    boardID(): string {
      return this.$store.getters.getBoardId;
    },
    shareURL(): string {
      return this.baseURL + "#" + this.boardID;
    },
    copyButtonText(): string {
      return this.copied ? "Copied" : "Copy Url";
    },
    copyButtonIcon(): string {
      return this.copied ? "mdi-clipboard-check-outline" : "mdi-clipboard-outline";
    }
  },
  methods: {
    copyToClipboard: function() {
      const el: HTMLInputElement | null = this.$el.querySelector("input[readonly='readonly']");
      if (el) {
        el.select();
      }
      document.execCommand('copy');
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 5000);
    },
    selectAll: function(event: any) {
      event.target.setSelectionRange(0, event.target.value.length)
    }
  }
});
